<template>
  <div>
    <div class="title_text">
      <div>
        <Icon type="ios-bookmark" size="18" color="#0466dd" />
        <span class="title_text2">项目信息</span>
      </div>
      <div class="project_id">{{ project_id }}</div>
    </div>
    <div class="data_div">
      <div class="data_div2">
        <Spin fix v-if="loading"></Spin>
        <div class="project_info_data">
          <div class="project_info_data_inner">
            <div class="project_info_title">项目简称：</div>
            {{ project_info.project_name }}
            <span class="update_subject_span" @click="update_project_name">（修改）</span>
          </div>
          <div class="project_info_data_inner">
            <div class="project_info_title_right">项目全称：</div>
            <div class="project_auth_div">
              {{ project_info.project_full_name }}
            </div>
          </div>
        </div>

        <div class="project_info_data">
          <div class="project_info_data_inner">
            <div class="project_info_title">财务项目组：</div>

            {{ project_info.project_group_name }}
            <span class="project_count" @click="view_group_project()">组中有（{{ project_info.group_project_count
            }}）个项目</span>
          </div>
          <div class="project_info_data_inner">
            <div class="project_info_title_right">项目归属部门：</div>
            {{ project_info.dep_name }}
          </div>
        </div>



        <div class="project_info_data">
          <div class="project_info_data_inner">
            <div class="project_info_title">项目客服权限：</div>
            <div class="project_auth_div">
              <Tag :color="item.is_admin == 1 ? 'success' : 'default'" v-for="(item, i) in project_info.auth_list"
                :key="i">
                <span class="guan_tag" v-if="item.is_admin == 1">(管理员)</span>{{ item.name }}
              </Tag>
              <!-- <div
                v-if="project_info.project_admin"
                class="add_project_auth"
                @click="click_add_project_auth"
              >
                <Icon type="ios-add-circle-outline" />调整权限
              </div> -->
            </div>
          </div>
          <div class="project_info_data_inner" @click="update_subject">
            <div class="project_info_title_right">项目主体：</div>
            <Tag color="error" class="update_tag" v-if="project_info.subject_name == ''">
              待完善（点击更新）</Tag>
            <!-- <Tag color="success" class="update_tag"  v-else>
              {{ project_info.subject_name }}</Tag> -->
            <div class="update_subject_span" v-else>
              <span style="color:#2c3e50">{{ project_info.subject_name }}
              </span>（更新）
            </div>
          </div>
        </div>
        <div class="project_info_data">
          <div class="project_info_data_inner">
            <div class="project_info_title">项目介绍：</div>
            <div class="project_auth_div">
              <div class="update_subject_span" @click="to_project_introduction(project_info.project_id)">{{
                project_info.project_introduction_str }}</div>

              <!-- <Tag :color="project_info.percentage_of_perfection == '100' ? 'success' : 'error'
                " @click="to_project_introduction(project_info.project_id)" class="xiangmujieshao">
                {{ project_info.project_introduction_str }}
              </Tag> -->
            </div>
          </div>
          <div class="project_info_data_inner">
            <div class="project_info_title_right">项目地区：</div>
            <div class="update_subject_span" @click="update_place_click(project_info.project_id)">

              <span style="color:#2c3e50;">
                {{
                  project_info.place_province == '' ? '未完善' : project_info.place_province + '/' + project_info.place_city
                    + '/' + project_info.place_district
                }}
              </span>（更新）
            </div>
          </div>
        </div>
        <div class="project_info_data">
          <div class="project_info_data_inner">
            <div class="project_info_title">项目性质：</div>
            <div class="project_auth_div">
              <div class="update_subject_span" @click="update_project_type(project_info.project_id)">
                <span style="color:#2c3e50;">
                  {{ project_info.project_type_name }}
                </span>（更新）
              </div>

              <!-- <Tag :color="project_info.percentage_of_perfection == '100' ? 'success' : 'error'
                " @click="to_project_introduction(project_info.project_id)" class="xiangmujieshao">
                {{ project_info.project_introduction_str }}
              </Tag> -->
            </div>

          </div>
          <div class="project_info_data_inner">
            <div class="project_info_title_right">项目创建时间：</div>
            <div class="project_auth_div">
              {{ project_info.project_create_time }}
            </div>
          </div>

        </div>
        <div class="project_info_data">
          <div class="project_info_data_inner">
            <div class="project_info_title">项目坐标：</div>
            <div class="project_auth_div">
              <div class="update_subject_span" @click="update_project_loaction(project_info.project_id)">
                <span style="color:#0466dd;" v-if="project_info.project_location_count > 0">
                  共{{ project_info.project_location_count }}个位置 （更新）
                </span>
                <span v-else style="color:#0466dd;">
                  未完善，点击更新
                </span>
              </div>

              <!-- <Tag :color="project_info.percentage_of_perfection == '100' ? 'success' : 'error'
                " @click="to_project_introduction(project_info.project_id)" class="xiangmujieshao">
                {{ project_info.project_introduction_str }}
              </Tag> -->
            </div>

          </div>


        </div>

        <!-- <div class="project_info_data">
          <div class="project_info_data_inner">
            <div class="project_info_title">项目创建时间：</div>
            <div class="project_auth_div">
              {{ project_info.project_create_time }}
            </div>
          </div>
          <div class="project_info_data_inner">
            <div class="project_info_title"></div>
          </div>
        </div> -->
      </div>
    </div>
    <business_contract ref="business_contract"></business_contract>


    <div class="title_text">
      <div>
        <Icon type="ios-bookmark" size="18" color="#0466dd" />
        <span class="title_text2">岗位结算信息(结算数据,不对外展示)</span>
      </div>
    </div>

    <div>
      <project_job ref="project_job"></project_job>
    </div>


    <div class="title_text">
      <div>
        <Icon type="ios-bookmark" size="18" color="#0466dd" />
        <span class="title_text2">项目市占率</span>
      </div>
    </div>
    <div>
      <project_market_share ref="project_market_share"></project_market_share>
    </div>


    <div class="title_text">
      <div>
        <Icon type="ios-bookmark" size="18" color="#0466dd" />
        <span class="title_text2">客服权限配置</span>
      </div>
      <div class="query_box"></div>
    </div>
    <div class="project_kefu_div">
      <project_auth ref="project_auth"></project_auth>
    </div>

    <div>
      <gaozhishu ref="gaozhishu"></gaozhishu>
    </div>


    <Modal v-model="update_subject_show" :closable="true" title="更新项目主体" :mask-closable="false" :footer-hide="true"
      width="400">
      <div class="update_subject_div">
        <div class="project_add_title">项目主体：</div>
        <Select clearable filterable v-model="project_info.subject_id">
          <Option v-for="item in subject_data" :value="item.subject_id" :key="item.subject_id">{{
            item.company_short_name }}
          </Option>
        </Select>
      </div>
      <div class="update_subject_btn_div">
        <Button type="primary" @click="update_sueject">确认更新</Button>
      </div>
    </Modal>


    <Modal v-model="update_place_show" :closable="true" title="更新项目地区" :mask-closable="false" :footer-hide="true"
      width="400">
      <div class="update_subject_div">
        <div class="project_add_title">项目地区：</div>
        <Cascader v-if="city_options" filterable :data="city_options" placeholder="请选择所属地区" v-model="update_place_model"
          v-width="420" />

      </div>
      <div class="update_subject_btn_div">
        <Button type="primary" @click="update_place_request">确认更新地区</Button>
      </div>
    </Modal>


    <Modal v-model="update_project_name_show" :closable="true" title="项目简称更新" :mask-closable="false" :footer-hide="true"
      width="400">
      <div class="update_subject_div">
        <div class="project_add_title">项目简称：</div>
        <Input v-model="update_project_name_txt" placeholder="请输入项目简称" style="width: 300px" />

      </div>
      <div class="update_subject_btn_div">
        <Button type="primary" @click="update_project_name_click">确认更新</Button>
      </div>
    </Modal>

    <!-- <Modal v-model="update_project_full_name_show" :closable="true" title="项目全称更新" :mask-closable="false" :footer-hide="true"
      width="400">
      <div class="update_subject_div">
        <div class="project_add_title">项目全称：</div>
        <Input v-model="update_project_name_txt" placeholder="请输入项目全称" style="width: 300px" />

      </div>
      <div class="update_subject_btn_div">
        <Button type="primary" @click="update_project_name_click">确认更新</Button>
      </div>
    </Modal> -->



    <Modal v-model="update_project_type_show" :closable="true" title="更新项目性质" :mask-closable="false" :footer-hide="true"
      width="400">
      <div>
        <Select v-model="update_project_type_id" style="width:350px">
          <Option v-for="item in project_info.type_options_list" :value="item.value" :key="item.value">{{ item.label }}
          </Option>
        </Select>
      </div>
      <div class="update_subject_btn_div">
        <Button type="primary" @click="update_project_type_confirm">确认更新项目性质</Button>
      </div>
    </Modal>
    <select_location ref="select_location" @change="select_location_change"></select_location>


  </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";
import business_contract from "./business_contract.vue";

import project_auth from "@/views/project_manage/component/auth.vue";
import project_job from "@/views/workbench/project_detail/component/project_job.vue";
import project_market_share from '@/views/workbench/project_detail/component/project_market_share.vue'
import gaozhishu from './gaozhishu.vue'
import select_location from './select_location.vue'
export default {
  name: "project_basic_info",
  components: {
    business_contract,
    project_auth,
    project_job,
    project_market_share,
    gaozhishu,
    select_location

  },
  data() {
    return {
      project_id: "",
      loading: false,
      project_info: {
        subject_id: "",
        project_introduction_str: "",
        percentage_of_perfection: 0,
      },
      subject_data: [],

      update_subject_show: false,
      update_place_show: false,
      city_options: [],
      update_place_model: [],
      update_project_type_show: false,
      update_project_type_id: "",

      update_project_name_txt: '',
      update_project_name_show: false,

      update_project_full_name_txt: '',
      update_project_full_name_show: false,

    };
  },

  mounted() { },
  methods: {

    select_location_change(e) {
      console.log('地图变化-往上传', e)
      this.$emit('location_change', { "count": e, 'project_id': this.project_id })
    },

    update_project_loaction() {
      console.log('点击更新坐标')
      console.log(this.project_id)
      this.$refs.select_location.open(this.project_id)
    },

    update_project_name_click() {
      var that = this;
      var obj = {
        project_id: this.project_id,
        project_name: this.update_project_name_txt
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/update_project_name",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_project_info();
            that.update_project_name_show = false
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    update_project_name() {
      this.update_project_name_show = true
      this.update_project_name_txt = this.project_info.project_name
    },

    update_project_full_name() {
      this.update_project_full_name_show = true
      this.update_project_full_name_txt = this.project_info.project_full_name
    },

    open_drawer(project_id) {
      console.log('打开权限管理')
      this.$refs.project_auth.open_drawer(project_id)
    },

    update_project_type_confirm() {
      var that = this;
      var obj = {
        project_id: this.project_id,
        type_id: this.update_project_type_id
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/update_project_type",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.update_project_type_show = false
            var type_name = res.data.type_name
            that.get_project_info();
            that.$emit('project_type_change', type_name)
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },


    //更新项目类型
    update_project_type(project_id) {

      this.update_project_type_id = this.project_info.project_type_id
      this.update_project_type_show = true

    },

    //获取地区数据
    get_city_options() {
      var that = this;
      var obj = {};
      http("post", process.env.VUE_APP_HOST + "/common/city_options", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.city_options = res.data.city_options;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //点击添加项目权限
    click_add_project_auth() {
      this.$refs.project_auth.open(this.project_id);
    },

    close_project_auth_change(item) {
      var that = this;
      this.$Modal.confirm({
        title: "提示",
        content: "<p>正在删除项目权限，删除后无该项目权限，是否继续？</p>",
        onOk: () => {
          that.close_project_auth(item);
        },
        onCancel: () => { },
      });
    },

    close_project_auth(item) {
      var that = this;
      var obj = {
        project_id: this.$route.query.project_id,
        user_id: item.user_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/del_myauth",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_project_info();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_business_contract(project_id) {
      console.log(project_id)
      if (project_id === undefined) {
        console.log('没有项目id')
      } else {
        this.project_id = project_id
      }
      this.$refs.business_contract.open(this.project_id, 1);
    },
    //更新主体
    update_sueject() {
      if (this.project_info.subject_id == "") {
        this.$Message.error("请先选择主体");
        return;
      }

      // if(this.$route.query.project_id==undefined){
      //   var project_id= this.$route.query.project_id
      // }else{
      //   var project_id= this.project_id
      // }

      var that = this;
      var obj = {
        project_id: this.project_id,
        subject_id: this.project_info.subject_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/update_subject",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.update_subject_show = false;
            that.get_project_info();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },


    //更新地区
    update_place_request() {

      // if(this.$route.query.project_id==undefined){
      //   var project_id= this.$route.query.project_id
      // }else{
      //   var project_id= this.project_id
      // }

      var that = this;
      var obj = {
        project_id: this.project_id,
        place_data: this.update_place_model,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/update_project_place",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.update_place_show = false;
            that.get_project_info();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    update_subject() {
      this.update_subject_show = true;
    },

    update_place_click() {
      this.update_place_show = true
      this.get_city_options()
    },

    //获取主体数据
    get_subject_data() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/subject_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.subject_data = res.data.subject_data;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //获取项目内容
    get_project_info() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      this.loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/project_info",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            console.log(11111, res.data);
            that.project_info = res.data;

            if (that.project_info.subject_id == "") {
              that.$Message.warning("当前主体未完善，请完善项目主体");
              that.update_subject_show = true;
            }

            that.$emit("change", res.data);
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading = false;
        })
        .catch((res) => {
          that.loading = false;

          console.log(res, "请求出错");
        });
    },

    to_project_introduction(project_id) {
      console.log(project_id);
      var that = this;
      if (project_id === undefined) {
      } else {
        this.project_id = project_id
      }
      console.log(this)
      open_new_page("/project_introduction?project_id=" + that.project_id);

      // var router = this.$route
      // console.log(router)

      // let routeUrl = this.$router.resolve({
      //   path: "/project_introduction",
      //   query: { project_id: that.project_id },
      // });
      // open_new_page(routeUrl)
    },

    view_group_project() {
      var str = "";
      for (var i = 0; i < this.project_info.group_project_name_list.length; i++) {
        if (i < 9) {
          var count = "0" + String(i + 1);
        } else {
          var count = String(i + 1);
        }

        str += count + "、" + this.project_info.group_project_name_list[i];
        str += "<br/>";
      }

      this.$Modal.info({
        title: "项目组中项目列表",
        content: "<p> " + str + "</p>",
      });
    },

    open(project_id, project_name) {
      this.project_id = project_id;
      console.log(this.project_id, 111111111111);
      this.get_project_info();
      this.get_subject_data();

      this.$refs.project_job.open(
        project_id,
        project_name
      );
      // this.$refs.project_job.click_add_job();

      this.$refs.project_auth.open(this.project_id);
      this.$refs.business_contract.open(this.project_id);
      this.$refs.project_market_share.open(this.project_id)
      this.$refs.gaozhishu.open(this.project_id)
    },

    click_add_gaozhishu(project_id) {
      this.$refs.gaozhishu.fast_open(project_id)
    },


    click_add_job(project_id) {
      this.$refs.project_job.click_add_job(project_id);
    },

    click_add_market_share() {
      this.$refs.project_market_share.click_update_data(this.project_id);
    }

  },
};
</script>

<style scoped>
.update_subject_span {
  font-size: 13px;
  color: #0466dd;
  cursor: pointer;
}

.kefu_card {
  padding: 10px 3px 10px 10px;
  border-radius: 5px;
  margin-right: 10px;
  margin-bottom: 10px;
  font-size: 13px;
  border: 1px solid #ccc;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.project_id {
  letter-spacing: 0px;
  font-size: 12px;
  color: #e5e5e5;
}

.kefu_card:hover {
  background: #0466dd;
  color: #fff
}

.cardicon {
  color: red
}

.kefu_card:hover .cardicon {
  background: #0466dd;
  color: #fff
}


.guan_tag {
  /* background: #fc861f; */
  font-size: 13px;
  /* border:1px solid #bfd9f8; */
  color: #fff;
  padding: 2px 0px;
  border-radius: 2px;
  margin-right: 5px;
}

.project_kefu_div {
  /* background: red; */
  display: flex;
  padding: 10px;
  flex-wrap: wrap;
}

.busc {
  color: #fff;
  cursor: pointer;
}

.project_count:hover {
  color: #0466dd;
}

.xiangmujieshao {
  cursor: pointer;
}

.project_count {
  cursor: pointer;
  margin-left: 15px;
  color: #ccc;
}

.project_info_data_inner {
  display: flex;
  font-size: 13px;
  margin-bottom: 5px;

  align-items: center;
}

.project_info_title {
  width: 100px;
  flex-shrink: 0;
}

.project_info_title_right {
  width: 100px;
  text-align: right;
  flex-shrink: 0;
}

.project_info_data {
  background: #fff;
  padding: 0px 10px 0 10px;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
}

.count_up {
  padding-top: 5px;
  height: 33px;
}

.count_card_div {
  display: flex;
  padding: 0 10px;
}

.iconjiesuan {
  font-size: 22px;
  color: #40ad15;
}

.iconjilu {
  font-size: 22px;
  color: #0466dd;
}

.title_text2 {
  font-weight: 600;
}

.export_table {
  font-size: 12px;
  color: #0466dd;
  font-weight: 300;
  margin-right: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  letter-spacing: 1px;
}

.update_subject_btn_div {
  padding: 20px 0 10px 0;
  display: flex;
  justify-content: flex-end;
}

.title_text3 {
  margin: 0px 10px 0 0px;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #ddd;
  padding: 10px 10px 5px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  letter-spacing: 2px;
}

.title_text {
  margin: 0px 10px 0 10px;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #ddd;
  padding: 10px 10px 5px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  letter-spacing: 2px;
}

.project_add_title {
  width: 100px;
  flex-shrink: 0;
}

.update_subject_div {
  display: flex;
  align-items: center;
}

.update_tag {
  cursor: pointer;
}

.card_main {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
}

.count_title {
  font-size: 13px;
  color: #333;
  margin-top: 5px;
}

.count_card {
  margin: 0 10px 10px 0;
  cursor: pointer;
  padding: 5px 10px 10px 10px;
  width: 130px;
  border-radius: 5px;
  background-color: #fff;
  text-align: center;
}

.data_div {
  padding: 10px 10px 10px 10px;
  border-radius: 5px;
}

.data_div2 {
  padding-top: 10px;
  background: #fff;
  border-radius: 5px;
  position: relative;
}

.query_box {
  display: flex;
  justify-content: flex-end;
}

.project_auth_div {
  display: flex;
  flex-wrap: wrap;
}

.add_project_auth {
  background: #eaeaea;
  border-radius: 3px;
  color: #8d8d8d;
  display: flex;
  align-items: center;
  padding: 0 5px;
  justify-content: center;
}

.add_project_auth:hover {
  background: #d8d8d8;
  cursor: pointer;
}
</style>
